import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { ISharedEntitiesManager } from './ISharedEntitiesManager';
import { Service } from './Service';
import { Region } from './Region';
import { ServiceSearchOptions } from './ServiceSearchOptions';

interface IRegion {
    id: string,
    cd: string,
    n: string,
    cntry: string,
    tn: string,
    tr: number
}

class SharedEntitiesManager implements ISharedEntitiesManager {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    allRegions(country?: string): Promise<Region[]> {
        let url = '/tools/misc/regions';
        if (country && country.length >= 0) {
            url = url + '/' + encodeURIComponent(country);
        }

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: url,
            method: HttpMethod.GET
        });

        return new Promise<Region[]>((resolve, reject) => {
            this.manager
                .get<any[]>(req)
                .then((res) => {
                    resolve(res.map(r => {
                        return new Region(r);
                    }));
                })
                .catch((err) => {
                    console.log(err);
                    resolve([]);
                })
        });
    }

    allServices(options?: ServiceSearchOptions): Promise<Service[]> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/misc/services',
            method: HttpMethod.POST
        }, options ?? {});

        return new Promise<Service[]>((resolve, reject) => {
            this.manager
                .get<any[]>(req)
                .then((res) => {
                    resolve(res.map(r => {
                        return new Service(r);
                    }));
                })
                .catch((err) => {
                    console.log(err);
                    resolve([]);
                })
        });
    }

    addRegion(region: Region): Promise<undefined> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/misc/regions',
            method: HttpMethod.PUT
        }, region);

        return new Promise<undefined>((resolve, reject) => {
            this.manager
                .send(req)
                .then((res) => {
                    if (res.ok) {
                        resolve(undefined);
                    } else {
                        reject(res.statusText);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                })
        });
    }
    addService(service: Service): Promise<undefined> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/misc/services',
            method: HttpMethod.PUT
        }, service);

        return new Promise<undefined>((resolve, reject) => {
            this.manager
                .send(req)
                .then((res) => {
                    if (res.ok) {
                        resolve(undefined);
                    } else {
                        reject(res.statusText);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                })
        });
    }

    deleteRegion(id: string): Promise<undefined> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/misc/regions/' + encodeURIComponent(id),
            method: HttpMethod.DELETE
        });

        return new Promise<undefined>((resolve, reject) => {
            this.manager
                .send(req)
                .then((res) => {
                    if (res.ok) {
                        resolve(undefined);
                    } else {
                        reject(res.statusText);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                })
        });
    }
    deleteService(id: string): Promise<undefined> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/misc/services/' + encodeURIComponent(id),
            method: HttpMethod.DELETE
        });

        return new Promise<undefined>((resolve, reject) => {
            this.manager
                .send(req)
                .then((res) => {
                    if (res.ok) {
                        resolve(undefined);
                    } else {
                        reject(res.statusText);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                })
        });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<ISharedEntitiesManager>('ISharedEntitiesManager', (frm) => {
        return new SharedEntitiesManager(frm);
    });
}

